export const faq = {
  title: "Frequently Asked Questions",
  faqs: [
    {
      question: "Who are we and what is our goal?",
      answer:
        "We are an organization dedicated to gathering a global social league of innovative actors, entrepreneurs, and investors with the goal of combating poverty and creating prosperity. We use our knowledge and implement effective social programs aligned with the United Nations Sustainable Development Goals (SDG2030) to break the cycle of poverty."
    },
    {
      question: "What is the Living Lab?",
      answer:
        "The Living Lab is a multiple platform, both physical and virtual, that addresses the World's Grand Challenges. It connects entrepreneurs, businesses, and governments to solve social challenges in poor and emerging communities, acting as a living laboratory to test and demonstrate innovative technologies like 3D printing for housing, Artificial Intelligence for health, blockchain, VR, AR, and much more."
    },
    {
      question: "What are the Sustainable Development Goals (SDGs)?",
      answer:
        "The SDGs are a collection of 17 global goals set by the UN in the 2030 Agenda. They represent an urgent call to action by all countries to promote prosperity while protecting the planet. Our organization promotes innovations and mobilizes a network of local talents and global partnerships to achieve these goals with high impact."
    },
    {
      question: "How does our platform work?",
      answer:
        "Our platform connects complex social challenges to the people capable of solving them, promoting collaborative action and open innovation. It serves as a meeting point for those seeking to make a difference in the challenges related to the 17 United Nations sustainable development goals."
    },
    {
      question: "How can I submit a solution on the platform?",
      answer:
        "To submit a solution, follow these steps: 1) Find a challenge related to the SDGs you wish to solve; 2) Accept the challenge and form a team; 3) Follow the guidelines and timeline of the challenge; 4) After completing, wait for the panel's evaluation. Winning solutions may receive cash prizes and the opportunity to be tested on a large scale."
    },
    {
      question: "What is the Social Impact Board?",
      answer:
        "The Social Impact Board is an international group of advisors who work alongside our organization on projects around the world. They play a crucial role in executing projects with significant social impact, such as the 'Operation Walk'."
    },
    {
      question: "Who are our partners?",
      answer:
        "Our partners include a diversity of solution ecosystems for each of the 17 SDGs. They work with us to solve challenges and create replicable models in other parts of the world. Some of our partners are: BoP Hub, SUCCESS INSTITUTE, Terra Foundation, Operation Walk Chicago, Porto Social, Project C.U.R.E., Singularity University, Transform Brazil, Trata Brasil Institute, and the World Toilet Organization (WTO)."
    }
  ]
};
